import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';
import { PreparerLayout } from '@/features/preparer/layout/PreparerLayout';
import { PreparerAuthGuard } from '@/features/preparer/auth/PreparerAuthGuard';

export const Route = createFileRoute('/preparer')({
  component: PreparerRoute,
});

function PreparerRoute() {
  const location = useLocation();

  // Check if we're on the login page
  const isLoginPage = location.pathname === '/preparer/login';

  // Login page should not be wrapped with auth guard or layout
  if (isLoginPage) {
    return <Outlet />;
  }

  // All other preparer routes need authentication and layout
  return (
    <PreparerAuthGuard>
      <PreparerLayout />
    </PreparerAuthGuard>
  );
}
